import { clamp } from "~/tools/clamp";

import type { Monaco } from "../_monaco";

export interface HeightSpec {
	minLines?: number;
	maxLines?: number;
}

export interface AutoHeightProps {
	monaco: null | typeof Monaco;
	editor: null | Monaco.editor.ICodeEditor;
	borderWidth: number;
	height: undefined | "auto" | HeightSpec;
}

export const calculateAutoHeight = ({ editor, borderWidth, height, monaco }: AutoHeightProps): number | undefined => {
	if (height == null || editor == null || monaco == null) {
		return undefined;
	}

	const contentHeight = editor.getContentHeight();
	const borderSize = 2 * borderWidth;

	if (height !== "auto") {
		const lineHeight = editor.getOption(monaco.editor.EditorOption.lineHeight);
		const padding = editor.getOption(monaco.editor.EditorOption.padding);
		const paddingSize = padding.top + padding.bottom;

		const limitedHeight = clamp(contentHeight, {
			min: height.minLines == null ? 0 : lineHeight * height.minLines + paddingSize,
			max: height.maxLines == null ? Number.POSITIVE_INFINITY : lineHeight * height.maxLines + paddingSize,
		});

		return limitedHeight + borderSize;
	}

	return contentHeight + borderSize;
};
